import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl, FormattedMessage } from "react-intl";
import { TranslationsProvider } from "@learningblocks/simulations/shared-components";

import { fetchTranslations } from "./locales/config";

import "./style.scss";

const outerNameIndexMap = { A: 9, B: 10, C: 11, D: 12, E: 13, F: 14 };

const idealTableData = [
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {
    type: "A",
    solutions: {
      Water: 40,
      "DNA Ladder": 10,
    },
  },
  {
    type: "B",
    solutions: {
      "10x DNA Cleavage Buffer": 5,
      "CCR5 DNA": 3,
      Water: 42,
    },
  },
  {
    type: "C",
    solutions: {
      "10x DNA Cleavage Buffer": 5,
      "CCR5 DNA": 3,
      "CAS9 Protein": 5,
      "Control gRNA": 2.5,
      Water: 34.5,
    },
  },
  {
    type: "D",
    solutions: {
      "10x DNA Cleavage Buffer": 5,
      "CCR5 DNA": 3,
      "CAS9 Protein": 5,
      "gRNA-a": 2.5,
      Water: 34.5,
    },
  },
  {
    type: "E",
    solutions: {
      "10x DNA Cleavage Buffer": 5,
      "CCR5 DNA": 3,
      "CAS9 Protein": 5,
      "gRNA-b": 2.5,
      Water: 34.5,
    },
  },
  {
    type: "F",
    solutions: {
      "10x DNA Cleavage Buffer": 5,
      "CCR5 DNA": 3,
      "CAS9 Protein": 5,
      "gRNA-c": 2.5,
      Water: 34.5,
    },
  },
];

class ResultsTable extends Component {
  constructor(props) {
    super(props);
  }

  getTableCellClass = (tube, innerSolution) => {
    if (this.props.table_type == "ideal") {
      return "actual-results-table__row--cell";
    }

    let actual = 0;
    if (
      Object.hasOwn(
        this.props.solutions[outerNameIndexMap[tube]].solutions,
        innerSolution
      )
    ) {
      actual =
        this.props.solutions[outerNameIndexMap[tube]].solutions[innerSolution];
    }

    let ideal = 0;
    if (
      Object.hasOwn(
        idealTableData[outerNameIndexMap[tube]].solutions,
        innerSolution
      )
    ) {
      ideal = idealTableData[outerNameIndexMap[tube]].solutions[innerSolution];
    }

    if (parseFloat(actual) !== parseFloat(ideal)) {
      return "actual-results-table__row--cell-error";
    } else {
      return "actual-results-table__row--cell";
    }
  };

  getTableCellValue = (tube, innerSolution) => {
    //get solutions in given tube
    let solutions = this.props.solutions[outerNameIndexMap[tube]].solutions;
    if (this.props.table_type === "ideal") {
      solutions = idealTableData[outerNameIndexMap[tube]].solutions;
    }

    if (Object.hasOwn(solutions, innerSolution)) {
      if (this.props.table_type !== "ideal") {
        if (solutions[innerSolution] !== null) {
          return parseFloat(solutions[innerSolution]);
        } else {
          return 0;
        }
      } else {
        return parseFloat(solutions[innerSolution]);
      }
    } else {
      return 0;
    }
  };

  render() {
    return (
      <div className="actual-results-table">
        <div className="actual-results-table__header">
          <div className="actual-results-table__header--title">
            <FormattedMessage
              id="Reagents"
              defaultMessage="Reagents"
              description=""
            />
          </div>
          <div className="actual-results-table__header--title">
            <FormattedMessage
              id="Final Concentration of Amount in Test Tube"
              defaultMessage="Final Concentration of Amount in Test Tube"
              description=""
            />
          </div>
          <div className="actual-results-table__header--title">
            <FormattedMessage
              id="Tube A"
              defaultMessage="Tube A"
              description=""
            />
          </div>
          <div className="actual-results-table__header--title">
            <FormattedMessage
              id="Tube B"
              defaultMessage="Tube B"
              description=""
            />
          </div>
          <div className="actual-results-table__header--title">
            <FormattedMessage
              id="Tube C"
              defaultMessage="Tube C"
              description=""
            />
          </div>
          <div className="actual-results-table__header--title">
            <FormattedMessage
              id="Tube D"
              defaultMessage="Tube D"
              description=""
            />
          </div>
          <div className="actual-results-table__header--title">
            <FormattedMessage
              id="Tube E"
              defaultMessage="Tube E"
              description=""
            />
          </div>
          <div className="actual-results-table__header--title">
            <FormattedMessage
              id="Tube F"
              defaultMessage="Tube F"
              description=""
            />
          </div>
        </div>

        <div className="actual-results-table__row">
          <div className="actual-results-table__row--cell">
            <FormattedMessage
              id="10x DNA Cleavage Buffer"
              defaultMessage="10x DNA Cleavage Buffer"
              description=""
            />
          </div>
          <div className="actual-results-table__row--cell">1x</div>
          <div
            className={this.getTableCellClass("A", "10x DNA Cleavage Buffer")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("A", "10x DNA Cleavage Buffer"),
              }
            )}
          >
            {this.getTableCellValue("A", "10x DNA Cleavage Buffer")}µl
          </div>
          <div
            className={this.getTableCellClass("B", "10x DNA Cleavage Buffer")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("B", "10x DNA Cleavage Buffer"),
              }
            )}
          >
            {this.getTableCellValue("B", "10x DNA Cleavage Buffer")}µl
          </div>
          <div
            className={this.getTableCellClass("C", "10x DNA Cleavage Buffer")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("C", "10x DNA Cleavage Buffer"),
              }
            )}
          >
            {this.getTableCellValue("C", "10x DNA Cleavage Buffer")}µl
          </div>
          <div
            className={this.getTableCellClass("D", "10x DNA Cleavage Buffer")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("D", "10x DNA Cleavage Buffer"),
              }
            )}
          >
            {this.getTableCellValue("D", "10x DNA Cleavage Buffer")}µl
          </div>
          <div
            className={this.getTableCellClass("E", "10x DNA Cleavage Buffer")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("E", "10x DNA Cleavage Buffer"),
              }
            )}
          >
            {this.getTableCellValue("E", "10x DNA Cleavage Buffer")}µl
          </div>
          <div
            className={this.getTableCellClass("F", "10x DNA Cleavage Buffer")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("F", "10x DNA Cleavage Buffer"),
              }
            )}
          >
            {this.getTableCellValue("F", "10x DNA Cleavage Buffer")}µl
          </div>
        </div>

        <div className="actual-results-table__row">
          <div
            className="actual-results-table__row--cell"
            aria-label="CCR5 DNA, concentration of 100 nanograms per microliter"
          >
            <FormattedMessage
              id="CCR5 DNA 100ng/µl"
              defaultMessage="CCR5 DNA 100ng/µl"
              description=""
            />
          </div>
          <div className="actual-results-table__row--cell">1x</div>
          <div
            className={this.getTableCellClass("A", "CCR5 DNA")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("A", "CCR5 DNA"),
              }
            )}
          >
            {this.getTableCellValue("A", "CCR5 DNA")}µl
          </div>
          <div
            className={this.getTableCellClass("B", "CCR5 DNA")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("B", "CCR5 DNA"),
              }
            )}
          >
            {this.getTableCellValue("B", "CCR5 DNA")}µl
          </div>
          <div
            className={this.getTableCellClass("C", "CCR5 DNA")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("C", "CCR5 DNA"),
              }
            )}
          >
            {this.getTableCellValue("C", "CCR5 DNA")}µl
          </div>
          <div
            className={this.getTableCellClass("D", "CCR5 DNA")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("D", "CCR5 DNA"),
              }
            )}
          >
            {this.getTableCellValue("D", "CCR5 DNA")}µl
          </div>
          <div
            className={this.getTableCellClass("E", "CCR5 DNA")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("E", "CCR5 DNA"),
              }
            )}
          >
            {this.getTableCellValue("E", "CCR5 DNA")}µl
          </div>
          <div
            className={this.getTableCellClass("F", "CCR5 DNA")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("F", "CCR5 DNA"),
              }
            )}
          >
            {this.getTableCellValue("F", "CCR5 DNA")}µl
          </div>
        </div>

        <div className="actual-results-table__row">
          <div
            className="actual-results-table__row--cell"
            aria-label={this.props.intl.formatMessage({
              id: "Cas9 Protein, 5 micrometers",
              defaultMessage: "Cas9 Protein, 5 micrometers",
              description: "",
            })}
          >
            <FormattedMessage
              id="CAS9 Protein 5µM"
              defaultMessage="CAS9 Protein 5µM"
              description=""
            />
          </div>
          <div className="actual-results-table__row--cell">1x</div>
          <div
            className={this.getTableCellClass("A", "CAS9 Protein")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("A", "CAS9 Protein"),
              }
            )}
          >
            {this.getTableCellValue("A", "CAS9 Protein")}µl
          </div>
          <div
            className={this.getTableCellClass("B", "CAS9 Protein")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("B", "CAS9 Protein"),
              }
            )}
          >
            {this.getTableCellValue("B", "CAS9 Protein")}µl
          </div>
          <div
            className={this.getTableCellClass("C", "CAS9 Protein")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("C", "CAS9 Protein"),
              }
            )}
          >
            {this.getTableCellValue("C", "CAS9 Protein")}µl
          </div>
          <div
            className={this.getTableCellClass("D", "CAS9 Protein")}
            aria-label={
              this.getTableCellValue("D", "CAS9 Protein") + " microliters"
            }
          >
            {this.getTableCellValue("D", "CAS9 Protein")}µl
          </div>
          <div
            className={this.getTableCellClass("E", "CAS9 Protein")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("E", "CAS9 Protein"),
              }
            )}
          >
            {this.getTableCellValue("E", "CAS9 Protein")}µl
          </div>
          <div
            className={this.getTableCellClass("F", "CAS9 Protein")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("F", "CAS9 Protein"),
              }
            )}
          >
            {this.getTableCellValue("F", "CAS9 Protein")}µl
          </div>
        </div>

        <div className="actual-results-table__row">
          <div
            className="actual-results-table__row--cell"
            aria-label={this.props.intl.formatMessage({
              id: "gRNA, 10 micrometers",
              defaultMessage: "gRNA, 10 micrometers",
              description: "",
            })}
          >
            <FormattedMessage
              id="gRNA 10µM"
              defaultMessage="gRNA 10µM"
              description=""
            />
          </div>
          <div className="actual-results-table__row--cell">1x</div>
          <div
            className={this.getTableCellClass("A", "Control gRNA")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("A", "Control gRNA"),
              }
            )}
          >
            {this.getTableCellValue("A", "Control gRNA")}µl
          </div>
          <div
            className={this.getTableCellClass("B", "Control gRNA")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("B", "Control gRNA"),
              }
            )}
          >
            {this.getTableCellValue("B", "Control gRNA")}µl
          </div>
          <div
            className={this.getTableCellClass("C", "Control gRNA")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("C", "Control gRNA"),
              }
            )}
          >
            {this.getTableCellValue("C", "Control gRNA")}µl
          </div>
          <div
            className={this.getTableCellClass("D", "gRNA-a")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("D", "Control gRNA"),
              }
            )}
          >
            {this.getTableCellValue("D", "gRNA-a")}µl
          </div>
          <div
            className={this.getTableCellClass("E", "gRNA-b")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("E", "Control gRNA"),
              }
            )}
          >
            {this.getTableCellValue("E", "gRNA-b")}µl
          </div>
          <div
            className={this.getTableCellClass("F", "gRNA-c")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("F", "Control gRNA"),
              }
            )}
          >
            {this.getTableCellValue("F", "gRNA-c")}µl
          </div>
        </div>

        <div className="actual-results-table__row">
          <div className="actual-results-table__row--cell">
            <FormattedMessage
              id="Water"
              defaultMessage="Water"
              description=""
            />
          </div>
          <div className="actual-results-table__row--cell">1x</div>
          <div
            className="actual-results-table__row--cell"
            aria-label={this.props.intl.formatMessage({
              id: "40 microliters",
              defaultMessage: "40 microliters",
              description: "",
            })}
          >
            40µl
          </div>
          <div
            className="actual-results-table__row--cell"
            aria-label={this.props.intl.formatMessage({
              id: "42 microliters",
              defaultMessage: "42 microliters",
              description: "",
            })}
          >
            42µl
          </div>
          <div
            className="actual-results-table__row--cell"
            aria-label={this.props.intl.formatMessage({
              id: "34.5 microliters",
              defaultMessage: "34.5 microliters",
              description: "",
            })}
          >
            34.5µl
          </div>
          <div
            className="actual-results-table__row--cell"
            aria-label={this.props.intl.formatMessage({
              id: "34.5 microliters",
              defaultMessage: "34.5 microliters",
              description: "",
            })}
          >
            34.5µl
          </div>
          <div
            className="actual-results-table__row--cell"
            aria-label={this.props.intl.formatMessage({
              id: "34.5 microliters",
              defaultMessage: "34.5 microliters",
              description: "",
            })}
          >
            34.5µl
          </div>
          <div
            className="actual-results-table__row--cell"
            aria-label={this.props.intl.formatMessage({
              id: "34.5 microliters",
              defaultMessage: "34.5 microliters",
              description: "",
            })}
          >
            34.5µl
          </div>
        </div>

        <div className="actual-results-table__row">
          <div className="actual-results-table__row--cell">
            <FormattedMessage
              id="DNA Ladder"
              defaultMessage="DNA Ladder"
              description=""
            />
          </div>
          <div className="actual-results-table__row--cell">1x</div>
          <div
            className={this.getTableCellClass("A", "DNA Ladder")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("A", "DNA Ladder"),
              }
            )}
          >
            {this.getTableCellValue("A", "DNA Ladder")}µl
          </div>
          <div
            className={this.getTableCellClass("B", "DNA Ladder")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("B", "DNA Ladder"),
              }
            )}
          >
            {this.getTableCellValue("B", "DNA Ladder")}µl
          </div>
          <div
            className={this.getTableCellClass("C", "DNA Ladder")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("C", "DNA Ladder"),
              }
            )}
          >
            {this.getTableCellValue("C", "DNA Ladder")}µl
          </div>
          <div
            className={this.getTableCellClass("D", "DNA Ladder")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("D", "DNA Ladder"),
              }
            )}
          >
            {this.getTableCellValue("D", "DNA Ladder")}µl
          </div>
          <div
            className={this.getTableCellClass("E", "DNA Ladder")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("E", "DNA Ladder"),
              }
            )}
          >
            {this.getTableCellValue("E", "DNA Ladder")}µl
          </div>
          <div
            className={this.getTableCellClass("F", "DNA Ladder")}
            aria-label={this.props.intl.formatMessage(
              {
                id: "{value} microliters",
                defaultMessage: "{value} microliters",
                description: "",
              },
              {
                value: this.getTableCellValue("F", "DNA Ladder"),
              }
            )}
          >
            {this.getTableCellValue("F", "DNA Ladder")}µl
          </div>
        </div>

        <div className="actual-results-table__footer">
          <div className="actual-results-table__footer--cell">
            <p style={{ height: "19px" }}></p>
          </div>
          <div
            className="actual-results-table__footer--cell"
            aria-label={this.props.intl.formatMessage({
              id: "The total volume for the DNA cleavage assay sample is V = 50 microliters",
              defaultMessage:
                "The total volume for the DNA cleavage assay sample is V = 50 microliters",
              description: "",
            })}
          >
            <FormattedMessage
              id="The total volume for the DNA cleavage assay sample is V = 50µl"
              defaultMessage="The total volume for the DNA cleavage assay sample is V = 50µl"
              description=""
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    solutions: state.solutions,
  };
};

const ResultsTableWithIntl = injectIntl(ResultsTable);

export const AssayResultsTable = connect(
  mapStateToProps,
  {}
)((props) => (
  <TranslationsProvider fetchTranslations={fetchTranslations}>
    <ResultsTableWithIntl {...props} />
  </TranslationsProvider>
));
